import { useRouteMatch } from 'react-router-dom';
import { FUNNEL_ROUTE } from '@src/Routes/links';

export const useGetOpeningId = (): string | undefined => {
  const match = useRouteMatch<{ openingId?: string }>({
    path: FUNNEL_ROUTE,
    sensitive: true,
    strict: true,
  });

  return match?.params.openingId;
};
